<template>
    <div>
        <button class="r-button rm-files__create" v-if="!recept.name && user.doctor" @click="show = true">Создать рецепт онлайн</button>
        <div class="rm-files__b-popup" v-if="show">
            <div class="rm-files__popup">
                <div class="b-popup">
                    <button class="calendar__close button-icon r-button" @click="show = false">
                        <span class="screen-reader">Закрыть окно</span>
                    </button>
                    <div class="b-popup__header">
                        <strong class="b-popup__title r-strong">Рецепт от {{form.date}}</strong>
                    </div>
                    <div class="b-popup__body">
                        <label class="b-popup__input field" v-if="!consultation.anonym">
                            <span class="field__caption">ФИО пациента (полностью)</span>
                            <input class="field__input field__blocked r-text-input " required placeholder="Иванов Иван Иванович" v-model="form.namePatient" disabled>
                        </label>
                        <label class="b-popup__input field" v-if="!consultation.anonym">
                            <span class="field__caption">Дата рождения</span>
                            <input class="field__input field__blocked field__date r-text-input" required type="date" placeholder="12.03.1990" v-model="form.birthday" disabled>
                        </label>
                        <label class="b-popup__input field">
                            <span class="field__caption">ФИО врача (полностью)</span>
                            <input class="field__input field__blocked r-text-input" required placeholder="Иванов Иван Иванович" v-model="form.nameDoctor" disabled>
                        </label>
                        <label class="b-popup__input field" v-if="clinic">
                            <span class="field__caption">Медицинское учреждение</span>
                            <input class="field__input field__blocked r-text-input" required v-model="form.nameClinic" disabled>
                        </label>
                        <label class="b-popup__input field">
                            <span class="field__caption">Рекомендации</span>
                            <textarea class="field__input r-text-input textarea" name="recommend" required v-model="form.recommend"></textarea>
                        </label>
                        <div class="b-popup__footer">
                            <button class="r-button button" @click="createRecept(form)">Отправить</button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import {mapState, mapMutations, mapActions} from 'vuex';
    import dayjs from "dayjs";

    export default {
        name: "ReceptCreate",
        computed: {
            ...mapState(['consultation', 'user']),
            ...mapState('recept', [
                'recept',
            ]),
        },
        data() {
            return {
                show: false,
                form: {
                    namePatient: null,
                    birthday: null,
                    nameDoctor: null,
                    nameClinic: null,
                    recommend: null,
                    date: null,
                    token: document.head.querySelector('meta[name="csrf-token"]').content,
                },
                clinic: false,
            }
        },
        mounted() {
            this.form.date = dayjs().format('DD.MM.YYYY');
            this.form.nameDoctor = this.consultation.doctor.user.name;

            if (!this.consultation.anonym) {
                this.form.namePatient = (this.consultation.family) ? this.consultation.family.name : this.consultation.patient.user.name;
                this.form.birthday = (this.consultation.family) ? this.consultation.family.birthday : this.consultation.patient.birthday;
            }

            if (this.consultation.doctor.clinic_id) {
                this.clinic = true;
                this.form.nameClinic = this.consultation.doctor.clinic.user.name;
            }
        },
        methods: {
            ...mapActions('recept', [
                'createRecept'
            ]),
            ...mapMutations('recept', [
                'setRecept',
                'spliceRecept'
            ]),
        },
        watch: {
            recept(event) {
                if (event.name) {
                    this.show = false;
                }
            }
        }
    }
</script>
